import analytics from '@repo/analytics';
import {
  useAuthenticationStore,
  authenticationStoreSelector,
} from '@repo/editor/src/stores/authenticationStore';
import {
  useUserStore,
  userStoreSelector,
} from '@repo/editor/src/stores/userStore';
import {
  primaryDarkTheme,
  primaryTheme,
  secondaryTheme,
} from '@repo/ui/components/Buttons';

import LinkButton from 'components/LinkButton/LinkButton';
import { IMAGE_SECTION_SLICE_BANNER_BUTTON_CLICK } from 'global/analyticsEvents';
import useWindowSize from 'global/utils/useWindowSize';

const getButtonTheme = (type, isMobile, useLightTheme) => {
  if (type === 'secondary') {
    return secondaryTheme;
  }
  if (useLightTheme) {
    return primaryDarkTheme;
  }
  return primaryTheme;
};

const BannerButton = ({
  label,
  link,
  type,
  isSignUp,
  useLightTheme = false,
  trackButtonClickGA = false,
}) => {
  const { isMobile } = useWindowSize();
  const user = useUserStore(userStoreSelector.user);
  const openAuthentication = useAuthenticationStore(
    authenticationStoreSelector.openAuthentication
  );

  const handleAuthentication = () => {
    openAuthentication({
      redirectUrl: link?.url,
    });
  };

  const onClick = () => {
    if (trackButtonClickGA) {
      analytics.track(IMAGE_SECTION_SLICE_BANNER_BUTTON_CLICK, {
        label,
        link: link?.url,
      });
    }
  };

  if (isSignUp) {
    return (
      <LinkButton
        buttonAction={handleAuthentication}
        href={link?.url || 'pricing'}
        isButton={!user}
        label={label}
        theme={getButtonTheme(type, isMobile, useLightTheme)}
        width="auto"
        onClick={onClick}
      />
    );
  }

  return (
    <LinkButton
      href={link?.url}
      label={label}
      theme={getButtonTheme(type, isMobile, useLightTheme)}
      width="auto"
      onClick={onClick}
    />
  );
};

export default BannerButton;
